const AUTH_KEYS = ['isLoggedIn', 'userInfo', 'isRole', 'auditStatus', 'role']

export function migrateAuthStorage() {
  AUTH_KEYS.forEach((key) => {
    const sessionVal = sessionStorage.getItem(key)
    const localVal = localStorage.getItem(key)
    if (sessionVal && (!localVal || localVal === 'null')) {
      localStorage.setItem(key, sessionVal)
    }
  })
}

export function getAuthItem(key) {
  const localVal = localStorage.getItem(key)
  if (localVal !== null && localVal !== 'null') {
    return localVal
  }
  return sessionStorage.getItem(key)
}

export function setAuthItem(key, value) {
  if (value === null || value === undefined) {
    localStorage.removeItem(key)
    sessionStorage.removeItem(key)
    return
  }
  localStorage.setItem(key, value)
  sessionStorage.setItem(key, value)
}

export function removeAuthItem(key) {
  localStorage.removeItem(key)
  sessionStorage.removeItem(key)
}

export function clearAuthStorage() {
  AUTH_KEYS.forEach(removeAuthItem)
}

export function parseAuthJson(key) {
  try {
    const val = getAuthItem(key)
    if (!val || val === 'null') {
      return null
    }
    return JSON.parse(val)
  } catch (e) {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/utils/authStorage.js